export function safeSetLocalStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.warn(error);
  }
}
export function safeRemoveLocalStorage(key) {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.warn(error);
  }
}
export function safeGetLocalStorageJson(key) {
  try {
    const value = localStorage.getItem(key);
    if (value) {
      return JSON.parse(value);
    }
  } catch (error) {
    // do nothing
  }
  return null;
}